var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      class: [
        "headlines",
        { "not-plain": !_vm.isplain },
        { empty: _vm.isempty },
        {
          hasHeadline:
            _vm.currentBoNavigationHeadlines &&
            _vm.currentBoNavigationHeadlines.length > 0
        }
      ],
      attrs: { fluid: "" }
    },
    [
      _vm.currentBoNavigationHeadlines &&
      _vm.currentBoNavigationHeadlines.length > 0
        ? _c(
            "div",
            { staticClass: "headline-wrapper" },
            [
              !_vm.isplain
                ? [
                    _vm._l(_vm.currentBoNavigationHeadlines, function(
                      headline,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "headline",
                            {
                              active:
                                headline.idfwheadline ===
                                _vm.selectedTab.idfwheadline
                            },
                            { "not-plain": !_vm.isplain },
                            { middle: _vm.isMiddleAndMobileHeadline(headline) }
                          ],
                          style: _vm.setBackground(headline, true)
                        },
                        [
                          _vm.enableAutoRotateMobile &&
                          headline.idfwheadline ===
                            _vm.selectedTab.idfwheadline &&
                            _vm.mobileBigAndBelow &&
                            _vm.currentBoNavigationHeadlines.length > 1
                            ? _c("circular-rotate", {
                                class: ["circular-rotate-container"],
                                attrs: {
                                  rotationInterval: _vm.rotationInterval,
                                  mobileBigAndBelow: _vm.mobileBigAndBelow
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { class: ["promo-container"] }, [
                            headline.imageurl
                              ? _c("div", {
                                  class: ["promo-image"],
                                  style: {
                                    backgroundImage:
                                      "url(" + headline.imageurl + ")"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { class: ["promo-title"] }, [
                              headline.promotext
                                ? _c(
                                    "span",
                                    {
                                      class: [
                                        "promotext",
                                        _vm.tabCssClass(headline)
                                      ]
                                    },
                                    [
                                      _c("span", { class: ["promo-label"] }, [
                                        _vm._v(_vm._s(headline.promotext))
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { class: ["datetime"] }, [
                                _vm._v(_vm._s(headline.datetimetext))
                              ])
                            ]),
                            _vm._v(" "),
                            headline.idfwheadlinetype === "MKPB" &&
                            (headline.linktype === "BONAVIGATION" ||
                              headline.linktype === "URL" ||
                              headline.linktype === "EXTERNAL" ||
                              headline.linktype === "NONE" ||
                              headline.linktype === "EVENT")
                              ? _c(
                                  "div",
                                  {
                                    class: [
                                      "promo-content ",
                                      {
                                        "link-to":
                                          headline.location &&
                                          headline.categoryname ===
                                            "BettingHeadlines"
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.goToHeadlineLink(headline)
                                      }
                                    }
                                  },
                                  [
                                    _c("div", { class: ["description"] }, [
                                      headline.title
                                        ? _c("h2", {
                                            class: ["title"],
                                            domProps: {
                                              innerHTML: _vm._s(headline.title)
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      headline.bodytext
                                        ? _c("p", {
                                            class: ["bodytext"],
                                            domProps: {
                                              innerHTML: _vm._s(
                                                headline.bodytext
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          !_vm.mobileBigAndBelow
                            ? _c(
                                "div",
                                { staticClass: "arrows-container" },
                                [
                                  _vm.currentBoNavigationHeadlines.length > 1
                                    ? _c(
                                        "div",
                                        { staticClass: "carousel__left" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn--icon theme--dark",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.selectPreviousTab(
                                                    headline
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "icon material-icons",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("navigate_before")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.enableAutoRotateDesktop &&
                                  headline.idfwheadline ===
                                    _vm.selectedTab.idfwheadline &&
                                    _vm.drawCircularRotateProgres &&
                                    _vm.currentBoNavigationHeadlines.length > 1
                                    ? _c("circular-rotate", {
                                        class: ["circular-rotate-container"],
                                        attrs: {
                                          rotationInterval: _vm.rotationInterval
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentBoNavigationHeadlines.length > 1
                                    ? _c(
                                        "div",
                                        { staticClass: "carousel__right" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn--icon theme--dark",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.selectNextTab(
                                                    headline
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "icon material-icons",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [_vm._v("navigate_next")]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    !_vm.mobileBigAndBelow &&
                    _vm.currentBoNavigationHeadlines.length > 0
                      ? _c(
                          "v-tabs",
                          {
                            staticClass: "headlines-tabs",
                            attrs: { "fixed-tabs": "", "align-with-title": "" }
                          },
                          _vm._l(_vm.currentBoNavigationHeadlines, function(
                            headline,
                            index
                          ) {
                            return _c(
                              "v-tab",
                              {
                                key: index,
                                class: [
                                  "tab",
                                  {
                                    active:
                                      headline.idfwheadline ===
                                      _vm.selectedTab.idfwheadline
                                  },
                                  _vm.tabCssClass(headline)
                                ],
                                style: _vm.setBackground(headline),
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.selectTabOnClick(
                                      headline.idfwheadline
                                    )
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "tab-header" }, [
                                  _vm._v(_vm._s(headline.header))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "tab-footer" }, [
                                  _vm._v(_vm._s(headline.footer))
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "datetime" }, [
                                  _vm._v(_vm._s(headline.datetimetext))
                                ])
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isplain
                ? [
                    _vm.currentBoNavigationHeadlines &&
                    _vm.currentBoNavigationHeadlines[0] &&
                    _vm.currentBoNavigationHeadlines[0].imageurl &&
                    this.$route.name !== "event"
                      ? _c("div", {
                          staticClass: "background-image",
                          style: {
                            backgroundImage:
                              "url(" +
                              _vm.currentBoNavigationHeadlines[0].imageurl +
                              ")"
                          }
                        })
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.category === "BettingHeadlines" &&
      (!_vm.currentBoNavigationHeadlines ||
        _vm.currentBoNavigationHeadlines.length === 0)
        ? _c("div", { staticClass: "ses" }, [_c("sports-breadcrumb")], 1)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6777306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6777306","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/headlines.vue
// module id = null
// module chunks = 